/* tslint:disable:max-line-length semicolon *//*
 * (c) Copyright 2018 e5 Workflow
 *
 * Angular default endpoint configuration for e5 Anywhere API generated 2018-8-10 14:13:25.
 */
import { Injectable } from '@angular/core';
import { IE5Config } from '../models/e5.config.model'

@Injectable()
export class E5ConfigurationService {

    public settings: IE5Config ;

    constructor() {
        this.settings = {
            env : {
                name : 'Default Configuration'
            },
            apiServer: {
                baseUrl: 'http://localhost:84/',
                scope: 'test'
            }
        }
    }
}
